import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { MyFleetVessels, VesselError } from '../../../models/my-fleet.model';

interface MyFleetVesselErrorTableProps {
  errors: VesselError[];
  vessels: MyFleetVessels | null;
}

export default function MyFleetVesselErrorTable({
  errors,
  vessels,
}: MyFleetVesselErrorTableProps) {
  return (
    <Table size="small" stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell sx={{ backgroundColor: 'primary.main' }}>IMO</TableCell>
          <TableCell sx={{ backgroundColor: 'primary.main' }}>Name</TableCell>
          <TableCell sx={{ backgroundColor: 'primary.main' }}>Error</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {errors.map((item) => (
          <TableRow key={item.imo}>
            <TableCell>{item.imo}</TableCell>
            <TableCell>
              {vessels?.find((v) => v.imo === item.imo)?.name ||
                'Unknown Vessel'}
            </TableCell>
            <TableCell>{item.message}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
